import React, { Component } from 'react';
import './App.css';
import PrimaryAppBar from '../components/PrimaryAppBar';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Route } from 'react-router-dom';
import NavTabs from './NavTabs/NavTabs';
import { connect } from 'react-redux';
import { Redirect, withRouter} from 'react-router-dom';
import * as actions from '../store/actions/index';
import OnBoarding from './Onboarding/OnBoarding';
import CircularProgress from '@material-ui/core/CircularProgress';
import axios from 'axios';
import { withStyles } from '@material-ui/core/styles';
//import { isEmpty } from 'lodash';

const styles = theme => ({
  palette: {
    primary: {
      main: '#B71C1C',
    },
    //secondary: green,
  },
  status: {
    danger: 'orange',
  },
  progress: {
    margin: theme.spacing.unit * 3,
  },
});

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
        typeOfAccount:localStorage.getItem('typeOfAccount')
    }

  }

  componentDidMount(){ 
    console.log('uniqueId app compo did mo: '+localStorage.getItem('token'))
    this.props.getUserInformation(localStorage.getItem('token'));
    this.props.getCaseInfo(this.props.match.params.id, localStorage.getItem('token'));
  }

  componentDidUpdate(prevProps, prevState){
    // if(this.props.isAuthenticated){
    //   if(!this.props.loadingCaseInfo){
      // if(this.props.isAuthenticated){
        if(!this.props.loadingCaseInfo){
        console.log('APP: this.props.caseData: '+JSON.stringify(this.props.caseData));
        console.log('APP: uniqueId '+JSON.stringify(localStorage.getItem('token')));
        console.log('APP: this.props.caseData.claimantUniqueId '+JSON.stringify(this.props.caseData.claimantUniqueId));
        console.log('APP: this.props.caseData.respondentUniqueId '+JSON.stringify(this.props.caseData.respondentUniqueId));
        
        let uniqueId = localStorage.getItem('token');
        let userType = '';
            if(this.props.caseData.claimantUniqueId == uniqueId){
                userType = 'claimant';
            }else if(this.props.caseData.respondentUniqueId == uniqueId){
                userType = 'respondent';
            }
        console.log('verification userType: '+userType)
        console.log('verification this.state.typeOfAccount: '+this.state.typeOfAccount)
        console.log('verification this.props.caseData[`${userType}_newAccount`]: '+this.props.caseData[`${userType}_newAccount`])

        var newAccount;
        try{
          newAccount = this.props.caseData[`${userType}_newAccount`];
        }catch(err){}
        
        if (this.state.typeOfAccount == 'user' ){
          if(newAccount !== null && newAccount !== undefined){
            if(!newAccount){
              localStorage.setItem('caseId', this.props.match.params.id);
              this.props.history.push(`${this.props.match.url}/home`);
            }else{
              console.log('verification pushing to onboarding ')
              localStorage.setItem('caseId', this.props.match.params.id);
              this.props.history.push(`${this.props.match.url}/onBoarding`);
            }
          }
        }
        else{
          localStorage.setItem('caseId', this.props.match.params.id);
          this.props.history.push(`${this.props.match.url}/home`);
        }
      }
    // }
  }

  render() {
    const { classes } = this.props;
    if(this.props.isAuthenticated){
      if(this.props.loadingCaseInfo){
        return(
          <CircularProgress size={50} thickness={3} className={classes.progress} />
        )
      }else{
        return(
          null
        )
      }
    }else{
      return(
        <Redirect to='/' />
      )
    }
    
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    loadingCaseInfo: state.caseInfo.loading,
    userType: state.caseInfo.userType,
    caseData: state.caseInfo.caseData,
    //newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`] ? state.caseInfo[`${state.caseInfo.userType}_newAccount`]/*['newAccount']*/ : null,
    newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`],
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    onTryAutoSignIn: (newAccount) => dispatch(actions.checkAuthState(newAccount)),
    getUserInformation: (uniqueId) => dispatch(actions.getUserInformation(uniqueId)),
    getCaseInfo: (caseId, uniqueId) => dispatch(actions.getCaseInfo(caseId, uniqueId)),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(App)));